import { Combobox, ComboboxOption } from "@/components/Base/Combobox";
import { Shop } from "@/types/v2";

export interface ActiveShopSelectProps {
  shops: Pick<Shop, "id" | "name">[];
  activeShopId: string | null | undefined;
  onChange: (shopId: string) => void;
}

// A shop that never got a name shows (and is searched by) its id instead.
const shopLabel = (shop: Pick<Shop, "id" | "name">) =>
  shop.name !== "" && shop.name !== "undefined" ? shop.name : shop.id;

export const ActiveShopSelect = ({
  shops,
  activeShopId,
  onChange,
}: ActiveShopSelectProps) => {
  const options: ComboboxOption[] = shops.map((shop) => ({
    value: shop.id,
    label: shopLabel(shop),
  }));

  // Combobox reports "" when the current item is picked again; navigating on
  // that would send the user to a broken URL.
  const handleValueChange = (shopId: string) => {
    if (shopId && shopId !== activeShopId) {
      onChange(shopId);
    }
  };

  return (
    <Combobox
      options={options}
      value={activeShopId ?? ""}
      onValueChange={handleValueChange}
      placeholder="Active Shop"
      searchPlaceholder="Search shops..."
      emptyText="No shop found."
      aria-label="Active shop"
      className="w-full"
      popoverClassName="w-[var(--radix-popover-trigger-width)]"
    />
  );
};
